<template>
  <div>
    <div class="banner">
      <div class="banner-background">
        <div class="banner-content">  
          <p class="p-one">COURT</p>
          <p class="p-two">直通互联网法院-网络取证</p>
          <p class="p-three" style="margin-bottom:10px">网页截屏方式固化证据</p>
          <p class="p-three">版权区块链上链记录、取证证据直通互联网法院</p>
          <button class="btn-138"  @click="goquzheng">去取证</button>
          <img src="./images/banner.png" alt='版权登记'/>
        </div>
      </div>
    </div>
    <div class="center-content">
      <ul>
        <li style="margin-left:55px">
          <div class="li-img-box li-img-box1">
              <img src="./images/11.png" class="img1" alt='版权登记'/>
              <p>国家授时中心授时，版权区块链，准确，不可修改性，取证司法认可</p>
              <img src="./images/01.png" class="img11" alt='版权登记'/>
          </div>
        </li>
        <li style="margin-left:100px;margin-right:100px;">
          <div class="li-img-box li-img-box2">
              <img src="./images/22.png" class="img2" alt='版权登记'/>
              <p>智能全自动取证，网页取证、录屏取证等多种取证方式，使证据更完整</p>
              <img src="./images/02.png" class="img22" alt='版权登记'/>
          </div>
        </li>
        <li>
          <div class="li-img-box li-img-box3">
              <img src="./images/33.png" class="img3" alt='版权登记'/>
              <p>实时监测、秒级取证，及时取证，便捷高效</p>
              <img src="./images/03.png" class="img33" alt='版权登记'/>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  metaInfo: {
      title: '取证介绍|版权服务专家|版权家',
      meta: [{                 // set meta
          name: 'keyWords',
          content: '版权服务,版权百科,版权,版权家,版权存证,版权交易,版权监测,版权维权,版权登记,版权公证,版权签名,数字版权,版全家,版权侵权取证,版权法律维权服务,区块链版权登记,区块链版权确权,区块链版权存证,区块链版权'
      },{
          name: 'Description',
          content: '取证介绍,版权家,人人都是创作者，人人都是版权人。版权家秉持让版权实现更大价值的使命，使用创新的版权区块链和版权签名技术，为版权人提供极致的版权存证、版权交易、版权监测、版权维权服务体验。'
      }]
  },
  name: "evidence",
  methods:{
    goquzheng(){
      this.$router.push({ path:'/evidenceWeb' })
    }
  }
  
};
</script>

<style scoped lang="less">
.banner{
  width:100%;
  height:460px;
  background:rgba(0,0,0,1);
  .banner-background{
    height:460px;
    background: url("./images/bg.png") no-repeat;
    background-size: cover;
    background-position: center;
    .banner-content{
      width:1334px;
      height:460px;
      margin:0 auto;
      position: relative;
      overflow: hidden;
      .p-one{
        font-size:20px;
        font-weight:300;
        color:rgba(255,255,255,1);
        line-height:28px;
        letter-spacing:2px;
        margin:78px 0px 10px;
      }
      .p-two{
        font-size:50px;
        font-weight:bold;
        color:rgba(255,255,255,1);
        line-height:70px;
        letter-spacing:6px;
        margin-bottom: 25px; 
      }
      .p-three{
        font-size:25px;
        font-weight:400;
        color:rgba(255,255,255,1);
        line-height:34px;
        letter-spacing:10px;
      }
      .btn-138{
        width:138px;
        height:40px;
        line-height: 40px;
        border:0;
        outline: none;
        background:rgba(255,216,0,1);
        border-radius:2px;
        font-size:14px;
        font-weight:bold;
        color:rgba(43,33,70,1);
        cursor: pointer;
        margin-top:40px;
      }
      img{
        width: 766px;
        height: 437px;
        position: absolute;
        top:22px;
        left:517px;
      }
    }
  }
}
.center-content{
  width:1334px;
  height:580px;
  margin:0 auto;
  ul{
    overflow: hidden;
    padding-top:137px;
    li{
      float: left;
      width:341px;
      height:394px;
      background:rgba(255,255,255,1);
      box-shadow:0px 2px 40px 0px rgba(29,31,108,0.04);
      list-style: none;
      .li-img-box{
        width:341px;
        height:394px; 
        background-repeat: no-repeat;       
        background-size: cover;
        overflow: hidden;
        position: relative;
        .img1{
          width:42px;
          height: 34px;
          margin:49px 0px 37px 150px;
        }
        .img11{
          width:219px;
          height: 172px;
          position: absolute;
          top:-109px;
          left:61px;
        }
        .img2{
          width:47px;
          height: 40px;
          margin:45px 0px 35px 147px;
        }
        .img22{
          width:258px;
          height: 172px;
          position: absolute;
          top:-109px;
          left:40px;
        }
        .img3{
          width:49px;
          height: 47px;
          margin:41px 0px 32px 146px;
        }
        .img33{
          width:261px;
          height: 172px;
          position: absolute;
          top:-109px;
          left:40px;
        }
        p{
          width: 270px;
          height: 44px;
          font-size:16px;
          color:rgba(51,51,51,1);
          line-height:22px;
          margin:0 auto;
        }
      }
      .li-img-box1{
        background-image: url("./images/1.png");
      }
      .li-img-box2{
        background-image: url("./images/2.png");
      }
      .li-img-box3{
        background-image: url("./images/3.png");
      }
    }
  }
}
</style>
